<div [ngSwitch]="type">
	<div *ngSwitchCase="'video'" [ngSwitch]="view">
		<div *ngSwitchCase="'editable'" class="drop-area">
			<video controls muted playsinline [ngStyle]="style">
				<source [src]="imagePath">
			</video>
		</div>
		<div *ngSwitchCase="'rename'" class="drop-area">
			<video controls muted playsinline [ngStyle]="style">
				<source [src]="imagePath">
			</video>
		</div>
		<div *ngSwitchDefault>
			<video controls muted playsinline [ngStyle]="style">
				<source [src]="imagePath">
			</video>
		</div>
	</div>
	<div *ngSwitchDefault [ngSwitch]="view">
		<div *ngSwitchCase="'editable'" class="drop-area">
			<img [ngStyle]="style" [src]="imagePath" alt="{{description}}" style="cursor: hand; cursor:pointer;">
		</div>
		<div *ngSwitchCase="'rename'" class="drop-area">
			<img [ngStyle]="style" [src]="imagePath" alt="{{description}}" style="cursor: hand; cursor:pointer;">
		</div>
		<div *ngSwitchDefault>
			<img [ngStyle]="style" [src]="imagePath" alt="{{description}}">
		</div>
	</div>

</div>





